import {StyledOrder} from "./index.styles";
import {Col, DatePicker, Input, Row, Select} from "antd";
import dayjs from "dayjs";
import {CalendarOutlined} from "@ant-design/icons";

import locale from "antd/es/date-picker/locale/ru_RU";

const {Option} = Select;

import advancedFormat from 'dayjs/plugin/advancedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import localeData from 'dayjs/plugin/localeData'
import weekday from 'dayjs/plugin/weekday'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import weekYear from 'dayjs/plugin/weekYear'

dayjs.extend(customParseFormat)
dayjs.extend(advancedFormat)
dayjs.extend(weekday)
dayjs.extend(localeData)
dayjs.extend(weekOfYear)
dayjs.extend(weekYear)

export const OrderNote = ({
                            lang,
                            disableAll,
                            disable,
                            admins,
                            order,

                            fio_entrant,
                            admin,

                            dateHandler,
                            subAdminsHandler,
                            numberHandler,
                            basisRuHandler,
                            basisKzHandler,
                          }:any) => {

  return(
    <StyledOrder>
      <span className="lang">{lang === "ru" ? "Русский" : "Казахский"}</span>
      <div className="content">
        <Row>
          <Col flex="0 0 500px" style={{display: "flex", justifyContent: "space-between"}} span={24}>

            <span style={{width: "45%", display: "flex", alignItems: "center"}}>
                №
              <Input onChange={e => numberHandler(e.target.value)} value={order.number} className="br"
                     style={{width: "100%", margin: "0 0 0 6px"}} disabled={disableAll}/>
            </span>
            <DatePicker
              value={dayjs(order.date, "DD.MM.YYYY")}
              defaultValue={dayjs(order.date, "DD.MM.YYYY")}
              suffixIcon={<CalendarOutlined style={{display: "none"}}/>}
              locale={locale}
              allowClear={false}
              style={{width: "45%"}}
              className="br"
              format={"DD.MM.YYYY"}
              onChange={(time, timeString) => dateHandler(dayjs(time))}
              disabled={disableAll || disable}
            />
          </Col>
          <Col span={24}>
            <span
              style={{fontWeight: 700}}>{lang === "ru" ? "О зачислении на обучение" : "Оқуға қабылдау туралы"}</span>
          </Col>
          <Col span={24}>
            <span style={{fontWeight: 700}}>{lang === "ru" ? "ПРИКАЗЫВАЮ:" : "БҰЙЫРАМЫН"}</span>
          </Col>
          <Col span={24}>
            {lang === "ru" ?
              <span>1. Зачислить <span>{fio_entrant}</span> в контингент учащихся в группу <span
                className="b">{order.group}</span></span>
              :
              <span>1. <span>{fio_entrant}</span> <span
                className="b">{order.group_kk}</span> топтың студенттер құрамына енгізілсін</span>}

          </Col>
          <Col span={24}>
            {lang === "ru" ? <span>2. Исполнение данного приказа возложить на заместителя по учебной части
              <Select
                showSearch
                bordered={false}
                style={{minWidth: 150}}
                className="br"
                value={order.sub_admin_id ? order.sub_admin_id : null}
                //@ts-ignore
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                onChange={(value, option) => subAdminsHandler(value, option)}
                disabled={disableAll}
              >
                {admins.map((item:any) => (
                  <Option key={item.fio} value={item.id}>{item.fio}</Option>
                ))}
              </Select>
            </span> :
              <span>2. Осы бұйрықтың орындалуын бақылау директордың оқу ісі жөніндегі орынбасары               <Select
                showSearch
                bordered={false}
                defaultValue="jack"
                style={{minWidth: 150}}
                className="br"
                value={order.sub_admin_id ? order.sub_admin_id : null}
                //@ts-ignore
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                onChange={(value, option) => subAdminsHandler(value, option)}
                disabled={disableAll}
              >
                {admins.map((item:any) => (
                  <Option key={item.fio} value={item.id}>{item.fio}</Option>
                ))}
              </Select> жүктелсін

            </span>}

          </Col>

          {lang === "ru" ?
            <Col span={24} style={{display: "flex", alignItems: "center"}}>
              <span style={{fontWeight: 700}}>Основание:</span>
              <Input onChange={e => basisRuHandler(e.target.value)} value={order.basis_ru} className="br"
                     style={{minWidth: 150}} disabled={disableAll}/>
            </Col>
            :
            <Col span={24} style={{display: "flex", alignItems: "center"}}>
              <span style={{fontWeight: 700}}>Негіздеме:</span>
              <Input onChange={e => basisKzHandler(e.target.value)} value={order.basis_kz} className="br"
                     style={{minWidth: 150}} disabled={disableAll}/>
            </Col>
          }
        </Row>
      </div>

      <div className="footer">
        <span>{lang === "ru" ? "Директор" : "Директоры"}</span>
        <span>{admin}</span>
      </div>
    </StyledOrder>
  )
}